var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("矩阵管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("平台列表")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("平台设置")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "Box" }, [
        _c("div", { staticClass: "table_tab" }, [
          _vm._m(0),
          _c("div", { staticClass: "inquiryTab" }, [
            _c("div", { staticClass: "inquiryTab_average" }, [
              _c(
                "div",
                { staticClass: "table" },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      ref: "theTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.tableDataS,
                        "header-cell-style": {
                          background: "#f8f8f8",
                          textAlign: "left",
                        },
                        toggleRowExpansion: { expanded: true },
                        "row-style": { height: "135px" },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "服务商等级", "min-width": "40" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { size: "small" },
                                  model: {
                                    value: props.row.name,
                                    callback: function ($$v) {
                                      _vm.$set(props.row, "name", $$v)
                                    },
                                    expression: "props.row.name",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            label: "允许上架数量",
                            prop: "categoryNo",
                            "min-width": "50",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.settingNumber(props.row)
                                        },
                                      },
                                    },
                                    [_vm._v("设置数量")]
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c(
                            "template",
                            { slot: "header" },
                            [
                              _c("span", [_vm._v("允许上架数量")]),
                              _c(
                                "el-tooltip",
                                {
                                  staticStyle: { "margin-left": "4px" },
                                  attrs: {
                                    effect: "dark",
                                    content:
                                      "各等级服务商平台上架商品的个数设置",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-question",
                                    staticStyle: { color: "#f2a626" },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            label: "普通商品比例",
                            prop: "normalProportion",
                            "min-width": "50",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("el-input", {
                                    staticStyle: { width: "80%" },
                                    attrs: { size: "small" },
                                    on: {
                                      input: (v) =>
                                        (props.row.normalProportion = v.replace(
                                          /[^0-9.]/g,
                                          ""
                                        )),
                                    },
                                    model: {
                                      value: props.row.normalProportion,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          props.row,
                                          "normalProportion",
                                          $$v
                                        )
                                      },
                                      expression: "props.row.normalProportion",
                                    },
                                  }),
                                  _c("span", { staticClass: "marginClass" }, [
                                    _vm._v("%"),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c(
                            "template",
                            { slot: "header" },
                            [
                              _c("span", [_vm._v("普通商品比例")]),
                              _c(
                                "el-tooltip",
                                {
                                  staticStyle: { "margin-left": "4px" },
                                  attrs: {
                                    effect: "dark",
                                    content:
                                      "各等级服务商售卖【普通商品】平台佣金设置的比例",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-question",
                                    staticStyle: { color: "#f2a626" },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            label: "礼包商品比例",
                            prop: "giftPackageProportion",
                            "min-width": "50",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("el-input", {
                                    staticStyle: { width: "80%" },
                                    attrs: { size: "small" },
                                    on: {
                                      input: (v) =>
                                        (props.row.giftPackageProportion =
                                          v.replace(/[^0-9.]/g, "")),
                                    },
                                    model: {
                                      value: props.row.giftPackageProportion,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          props.row,
                                          "giftPackageProportion",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "props.row.giftPackageProportion",
                                    },
                                  }),
                                  _c("span", { staticClass: "marginClass" }, [
                                    _vm._v("%"),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c(
                            "template",
                            { slot: "header" },
                            [
                              _c("span", [_vm._v("礼包商品比例")]),
                              _c(
                                "el-tooltip",
                                {
                                  staticStyle: { "margin-left": "4px" },
                                  attrs: {
                                    effect: "dark",
                                    content:
                                      "各等级服务商售卖【礼包商品】平台佣金设置的比例",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-question",
                                    staticStyle: { color: "#f2a626" },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            label: "身份商品比例",
                            prop: "vipProportion",
                            "min-width": "50",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("el-input", {
                                    staticStyle: { width: "80%" },
                                    attrs: { size: "small" },
                                    on: {
                                      input: (v) =>
                                        (props.row.vipProportion = v.replace(
                                          /[^0-9.]/g,
                                          ""
                                        )),
                                    },
                                    model: {
                                      value: props.row.vipProportion,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          props.row,
                                          "vipProportion",
                                          $$v
                                        )
                                      },
                                      expression: "props.row.vipProportion",
                                    },
                                  }),
                                  _c("span", { staticClass: "marginClass" }, [
                                    _vm._v("%"),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c(
                            "template",
                            { slot: "header" },
                            [
                              _c("span", [_vm._v("身份商品比例")]),
                              _c(
                                "el-tooltip",
                                {
                                  staticStyle: { "margin-left": "4px" },
                                  attrs: {
                                    effect: "dark",
                                    content:
                                      "各等级服务商售卖【身份商品】平台佣金设置的比例",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-question",
                                    staticStyle: { color: "#f2a626" },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _c("el-table-column", {
                        attrs: {
                          label: "说明",
                          prop: "remarks",
                          "min-width": "50",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _vm._v(" " + _vm._s(props.row.remarks) + " "),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "submit" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "submit_btn",
                    staticStyle: {
                      "background-color": "#f2a626",
                      border: "1px solid #f2a626",
                    },
                    attrs: { type: "primary" },
                    on: { click: _vm.back },
                  },
                  [_vm._v("返 回")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "submit_btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.save },
                  },
                  [_vm._v("确 认")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置数量",
            visible: _vm.dialogUser,
            "append-to-body": "",
            width: "780px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogUser = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-search" }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c("div", [_vm._v("默认允许上架数量")]),
              _c(
                "div",
                {
                  staticStyle: { "margin-left": "8px", "margin-right": "8px" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "86px" },
                    attrs: {
                      placeholder: "请输入个数",
                      size: "small",
                      clearable: "",
                    },
                    model: {
                      value: _vm.maxGoodsNum,
                      callback: function ($$v) {
                        _vm.maxGoodsNum = $$v
                      },
                      expression: "maxGoodsNum",
                    },
                  }),
                ],
                1
              ),
              _c("div", [_vm._v("个")]),
            ]),
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                { staticStyle: { "margin-right": "20px" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入用户信息",
                      clearable: "",
                      size: "small",
                    },
                    model: {
                      value: _vm.keywords,
                      callback: function ($$v) {
                        _vm.keywords = $$v
                      },
                      expression: "keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.searchData },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("div", [
            _c(
              "div",
              {
                staticStyle: {
                  "max-height": "400px",
                  "overflow-y": "auto",
                  "margin-top": "20px",
                },
              },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%", "margin-bottom": "10px" },
                    attrs: {
                      border: "",
                      data: _vm.tableData,
                      "tooltip-effect": "dark",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "用户ID",
                        width: "160px",
                        prop: "userId",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "username",
                        label: "用户昵称",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "phone",
                        label: "电话号码",
                        width: "160px",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "address", label: "允许个数" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c(
                                  "div",
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入个数",
                                        clearable: "",
                                        size: "small",
                                      },
                                      model: {
                                        value: scope.row.maxGoodsNum,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "maxGoodsNum",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.maxGoodsNum",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "line-height": "30px",
                                      "margin-left": "8px",
                                    },
                                  },
                                  [_vm._v("个")]
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { float: "right", "margin-top": "10px" } },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.pageNo,
                    "page-sizes": [10, 20, 30, 40],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
            _c("div", {
              staticStyle: {
                width: "780px",
                height: "0px",
                border: "1px solid #d9d9d9",
                opacity: "1",
                "margin-top": "70px",
              },
            }),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "14px",
                  display: "flex",
                  "justify-content": "flex-end",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "c-btn",
                    on: {
                      click: function ($event) {
                        _vm.dialogUser = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "q-btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.submit },
                  },
                  [_vm._v("确认")]
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "inquiry" }, [
      _c("div", { staticClass: "headerbox" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "title_left" }),
          _vm._v(" 平台设置 "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }